// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__12wCM","content":"GlobalSearch_content__2RapC"};